<template>
  <div class="product-item-appeal">
    <img
      class="hero-image"
      v-lazy="'/static/products/' + name + '/product.png'"
      :alt="productName"
    />
    <div class="body">
      <p class="appeal">{{ appeal }}</p>
      <div class="recommend">
        <p class="recommend-label">こんな方におすすめ</p>
        <ul class="recommend-list">
          <li v-for="(item, index) in recommendItems" :key="index">
            {{ item }}
          </li>
        </ul>
      </div>
      <router-link
        v-bind:to="{
          name: 'ProductType',
          params: {
            name: name,
            type: 'feature',
          },
        }"
        class="cta-button"
      >
        {{ productName }}の商品情報を見る
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    name: String,
    productName: String,
    title: String,
    appeal: String,
    detail: String,
    subtitle: String,
    recommends: { type: Array, default: () => [] },
  },
  computed: {
    recommendItems() {
      if (this.recommends && this.recommends.length) return this.recommends
      return this.title ? [this.title] : []
    },
  },
}
</script>

<style scoped>
.product-item-appeal {
  display: flex;
  flex-direction: column;

  height: 100%;
  min-height: 655px;

  text-decoration: none;

  color: #4d4d4d;
  background-color: #ffffff;
}

.hero-image {
  display: block;

  width: 100%;

  flex-shrink: 0;
}

.body {
  display: flex;
  flex-direction: column;

  flex: 1;
  padding: 14px 0 18px;
}

.for-outgoing .body {
  background-color: rgb(232, 248, 237);
}

.for-incoming .body {
  background-color: rgb(233, 245, 255);
}

.appeal {
  font-size: 16px;
  font-weight: bold;
  line-height: 1.6;

  margin: 0 0 18px;

  white-space: pre-line;
}

.for-outgoing .appeal {
  color: rgb(45, 183, 68);
}

.for-incoming .appeal {
  color: rgb(16, 106, 203);
}

.recommend {
  flex: 1;

  margin-bottom: 18px;
}

.recommend-label {
  font-size: 16px;
  font-weight: bold;

  margin: 0 0 8px;

  color: #1a1a1a;
}

.recommend-list {
  font-size: 14px;
  font-weight: bold;
  line-height: 1.4;

  margin: 0;
  padding-left: 24px;

  list-style-type: disc;

  color: #333333;
}

.recommend-list li::marker {
  color: #000000;
}

.recommend-list li {
  margin-bottom: 0;
}

.cta-button {
  font-size: 15px;
  font-weight: bold;

  display: block;

  margin-top: auto;
  padding: 6px 10px;

  text-align: center;
  text-decoration: none;
  letter-spacing: 0.5px;

  color: #ffffff;
  border-radius: 20px;

  transition: opacity 0.3s;
}

.for-outgoing .cta-button {
  background-color: rgb(45, 183, 68);
}

.for-incoming .cta-button {
  background-color: rgb(16, 106, 203);
}

.cta-button:hover {
  opacity: 0.7;
}

@media (max-width: 1099px) {
  .product-item-appeal {
    min-height: 0;
    width: 90%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modules/ProductItemAppeal.vue